"use client";

import React from "react";
import { MessageSquareText, BellRing, CircleCheck, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InstantMissedCallAlerts() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: visualRef,
    isVisible: isVisualVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="201869" id="affordabletoothreplacement" className="bg-secondary/30 py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div ref={contentRef} className={`lg:col-span-7 flex flex-col items-start space-y-8 transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Badge variant="secondary" className="bg-primary/10 text-primary hover:bg-primary/20 px-3 py-1 rounded-full text-sm font-medium">
              Premium Dental Care
            </Badge>
            
            <div className="space-y-6">
              <div className="flex flex-col sm:flex-row sm:items-center gap-4 md:gap-6">
                <h2 className="font-serif text-4xl md:text-5xl lg:text-7xl font-bold tracking-tight text-foreground leading-[1.05]">Value+ Quality</h2>
                <img src="https://proud-garfish.10web.cloud/wp-content/uploads/2026/04/smartchoice.jpg" alt="Quality Excellence Seal" className="h-24 md:h-32 lg:h-40 w-auto object-contain" />
              </div>
              <p className="font-default text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">Our vision at Smart Choice Denture &amp; Implants is to make dentures and dental implants accessible, affordable, and comfortable for every patient. We are passionate about helping people with missing teeth regain their smile, confidence, and quality of life. Through specialized care and modern treatment options, we provide a comfortable and efficient path to a new smile. Our aim is to provide:&nbsp;&nbsp;<br /><br />1. High-Quality Care at Exceptional Value:<br /><div data-ast-id="f:/src/pages/Home/sections/InstantMissedCallAlerts.tsx|sig:54dm7i" data-ast-start="2465" data-ast-end="2756" contenteditable="false">We combine advanced treatment with competitive pricing to give patients the best possible outcome without unnecessary cost.</div><div data-ast-id="f:/src/pages/Home/sections/InstantMissedCallAlerts.tsx|sig:52quo8" data-ast-start="2756" data-ast-end="2936"><br />2. Focused Expertise in Dentures &amp; Implants</div><div data-ast-id="f:/src/pages/Home/sections/InstantMissedCallAlerts.tsx|sig:51ojgj" data-ast-start="2936" data-ast-end="3176">By specializing in tooth replacement, we deliver efficient treatment and predictable, long-lasting results.</div><div data-ast-id="f:/src/pages/Home/sections/InstantMissedCallAlerts.tsx|sig:4oypv3" data-ast-start="3176" data-ast-end="3350"><br />3. Efficient, Patient-Centered Experience</div><div data-ast-id="f:/src/pages/Home/sections/InstantMissedCallAlerts.tsx|sig:4nwj3k" data-ast-start="3350" data-ast-end="3595">Our streamlined approach minimizes delays and maximizes comfort, helping you restore your smile with confidence.</div></p>
            </div>

            
            

            <div className="pt-4">
              <Button asChild size="lg" className="rounded-full shadow-lg hover:shadow-xl transition-all duration-300 group bg-primary text-primary-foreground">
                <Link href="/ContactUsPage">
                  Free Consultation
                  <ArrowRight className="ml-2 size-4 group-hover:translate-x-1 transition-transform" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={visualRef} className={`lg:col-span-5 relative transition-all duration-1000 delay-200 ease-out ${isVisualVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-tr from-primary/10 via-secondary/20 to-transparent rounded-full blur-3xl -z-10" />
            
            <div className="relative w-full max-w-md mx-auto">
              {}
              
              
            </div>
          </div>

        </div>
      </div>
    </section>;
}